export default class Livestream {
    constructor() {
        if ( typeof( LBXPlayer ) == 'undefined' ) {
            return;
        }

        const element = document.querySelector( '[data-livestream]' );

        if ( element === null ) {
            return;
        }

        const streams = [
            '0a54e479-6ea9-4d1a-8963-c0bae431df97',
            '548b99a7-2246-456d-8810-8f52d0424da5'
        ]

        const navigation = document.createElement( 'ul' );
        navigation.className = 'livestream__navigation';

        const tabs = document.createElement( 'div' );
        tabs.className = 'livestream__tabs';

        streams.forEach( ( key, index ) => {
            const navItem = document.createElement( 'li' );
            navItem.className = 'livestream__navigation__item';
            navItem.innerHTML = 'Live Cam ' + (index + 1);

            if ( index === 0 ) {
                navItem.classList.add( 'active' );
            }

            const tabsContent = document.createElement( 'div' );
            tabsContent.className = 'livestream__tabs__content';
            
            const iframe = document.createElement( 'iframe' );
            iframe.src = 'https://player.smartcams.cz/v2/?id=' + key;
            iframe.style.border = 'none';
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.allowfullscreen = true; 

            tabsContent.appendChild( iframe );

            if ( index === 0 ) {
                tabsContent.classList.add( 'active' );
            }

            navigation.appendChild( navItem );
            tabs.appendChild( tabsContent );
        } )

        element.appendChild( navigation );
        element.appendChild( tabs );

        this.bindEvents();
    }

    bindEvents () {
        document.addEventListener( 'click', ( e ) => {
            let target = e.target;

            if ( target.matches( '.livestream__navigation__item' ) ) {
                const parent = target.closest( '[data-livestream]' );
                const navItems = parent.querySelectorAll( '.livestream__navigation__item' );
                const tabsContents = parent.querySelectorAll( '.livestream__tabs__content' );
                const index = Array.from( navItems ).indexOf( target );

                navItems.forEach( ( item ) => {
                    item.classList.remove( 'active' );
                    target.classList.add( 'active' );
                } );
    
                tabsContents.forEach( ( item ) => {
                    item.classList.remove( 'active' );
                    tabsContents[ index ].classList.add( 'active' );
                } );
            }
        } );
    }
}